// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_liquidateCash__wmlcl {
}

.styles_liquidateCashHeader__bjUV3 {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #cfcfcf;
  margin-bottom: 40px;
}

.styles_liquidateCashHeader__bjUV3 h2 {
  font-family: BebasNeue;
  font-weight: 400;
  font-size: 30px;
  line-height: 100%;
}

.styles_liquidateCashContent__rRegO {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 56px;
}

.styles_liquidateCashInfo__NThY2{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.styles_liquidateCashInfo__NThY2 p{
  margin: 0
}

.styles_liquidateCashInfo__NThY2 p span{
  font-weight: 600;
}

.styles_liquidateCashInfo__NThY2 p:nth-child(2) span{
  font-weight: 400;
  text-decoration: underline;
}

.styles_liquidateCashFooter__sdvVb{
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/cash-not-received/styles/styles.module.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,SAAS;AACb;;AAEA;EACI;AACJ;;AAEA;EACI,gBAAgB;AACpB;;AAEA;EACI,gBAAgB;EAChB,0BAA0B;AAC9B;;AAEA;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACvB","sourcesContent":[".liquidateCash {\n}\n\n.liquidateCashHeader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 1px solid #cfcfcf;\n  margin-bottom: 40px;\n}\n\n.liquidateCashHeader h2 {\n  font-family: BebasNeue;\n  font-weight: 400;\n  font-size: 30px;\n  line-height: 100%;\n}\n\n.liquidateCashContent {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-bottom: 56px;\n}\n\n.liquidateCashInfo{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.liquidateCashInfo p{\n    margin: 0\n}\n\n.liquidateCashInfo p span{\n    font-weight: 600;\n}\n\n.liquidateCashInfo p:nth-child(2) span{\n    font-weight: 400;\n    text-decoration: underline;\n}\n\n.liquidateCashFooter{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"liquidateCash": `styles_liquidateCash__wmlcl`,
	"liquidateCashHeader": `styles_liquidateCashHeader__bjUV3`,
	"liquidateCashContent": `styles_liquidateCashContent__rRegO`,
	"liquidateCashInfo": `styles_liquidateCashInfo__NThY2`,
	"liquidateCashFooter": `styles_liquidateCashFooter__sdvVb`
};
export default ___CSS_LOADER_EXPORT___;
